import cn from 'classnames';

import TempoTrayAdSource from 'images/tempo-intro-ad-1.png';
import TempoChickenPiccata from 'images/tempo-intro-ad-2.png';
import { PARTNERSHIP_RESOURCE_TYPES } from 'lib/constants/signUp';

const STYLE_VARIANTS = {
  adSource: {
    rightImage: { src: TempoTrayAdSource, alt: 'Tempo Garlic Sesame Chicken' },
    leftImage: { src: TempoChickenPiccata, alt: 'Tempo Chicken Piccata' },
    rightClassName:
      'absolute -right-6 -top-5 w-24 bp1:inset-1/2 bp1:top-4 bp1:w-52 bp1:translate-x-64',
    leftClassName:
      'absolute -left-6 -top-5 w-24 bp1:inset-1/2 bp1:top-16 bp1:w-52 bp1:-translate-x-[35rem]',
  },
};

const ImageSection = ({ variant = 'adSource', partnershipData }) => {
  const partnershipImages =
    partnershipData?.partnership?.resources.flatMap(resource =>
      resource.resourceType === PARTNERSHIP_RESOURCE_TYPES.INTRO_IMAGE ? [resource.url] : []
    ) || [];

  if (partnershipImages.length > 0) {
    const rightImage = partnershipImages[1] || '';
    const leftImage = partnershipImages[0] || '';

    return (
      <>
        <div className="bg-tempo-blue-120 p-0" />
        <div>
          {rightImage && (
            <img
              className={STYLE_VARIANTS[variant].rightClassName}
              src={rightImage}
              alt="Partnership meal"
            />
          )}
          {leftImage && (
            <img
              className={STYLE_VARIANTS[variant].leftClassName}
              src={leftImage}
              alt="Partnership meal"
            />
          )}
        </div>
      </>
    );
  }

  const { rightImage, leftImage, rightClassName, leftClassName } = STYLE_VARIANTS[variant];

  return (
    <>
      <div className="bg-tempo-blue-120 p-0" />
      <div>
        <img className={cn(rightClassName)} src={rightImage.src} alt={rightImage.alt} />
        <img className={cn(leftClassName)} src={leftImage.src} alt={leftImage.alt} />
      </div>
    </>
  );
};

export default ImageSection;
